import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SaleOrderRequest from '../entities/sale-order-request/sale-order-request'
import SaleOrderRequestDetail from '../entities/sale-order-request/sale-order-request-detail'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import Ref from '../entities/ref'
interface SaleOrderRequestState extends ListState<SaleOrderRequest> {
    statuses: Array<Ref>
    lineTotalCount: number,
    lineCurrentPage: number,
    linePageSize: number,
    lineLoading: boolean,
    lineGiftTotalCount: number,
    lineGiftCurrentPage: number,
    lineGiftPageSize: number,
    lineGiftLoading: boolean,
    historyTotalCount: number,
    historyCurrentPage: number,
    historyPageSize: number,
    historyLoading: boolean,
}
class SaleOrderRequestModule extends ListModule<SaleOrderRequestState, any, SaleOrderRequest>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SaleOrderRequest>(),
        loading: false,
        statuses: new Array<Ref>(),
        lineTotalCount:0,
        lineCurrentPage:1,
        linePageSize:10,
        lineLoading:false,
        lineGiftTotalCount: 0,
        lineGiftCurrentPage: 1,
        lineGiftPageSize: 10,
        lineGiftLoading: false,
        historyTotalCount: 0,
        historyCurrentPage: 1,
        historyPageSize: 10,
        historyLoading: false,
    }
    actions = {
        async getAll(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/SoRequest', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<SaleOrderRequest>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async get(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            let reponse=await Ajax.get(`/api/services/app/SoRequest/${payload.data.id}/info` );
            return reponse.data.result as SaleOrderRequestDetail;
        },
        async getHistories(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            let reponse=await Ajax.get(`/api/services/app/SoRequest/${payload.data.id}/histories` );
            return reponse.data.result;
        },
        async getSORLines(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            let reponse=await Ajax.get(`/api/services/app/SoRequest/${payload.data.id}/lines` );
            return reponse.data.result as [];
        },
        async getStatusesForSelect(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            const {data:{result} } = await Ajax.get('/api/services/app/SoRequest/GetStatusForSelect', { params : payload.data });
            context.state.statuses = result.items as Ref[];
        },
        async create(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            await Ajax.post('/api/services/app/SoRequest', payload.data);
        },
        async cancel(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            await Ajax.put(`/api/services/app/SoRequest/${payload.data.id}/CC-Cancel`, payload.data);
        },
        async reject(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            await Ajax.put(`/api/services/app/SoRequest/${payload.data.id}/Wh-Reject`, payload.data );
        },
        async finish(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            await Ajax.put(`/api/services/app/SoRequest/${payload.data.id}/Finish`);
        },
        async recheck(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            await Ajax.put(`/api/services/app/SoRequest/${payload.data.id}/Recheck`);
        },
        async recheckAll(context: ActionContext<SaleOrderRequestState, any>, payload: any) {
            await Ajax.put('/api/services/app/SoRequest/RecheckAll', payload.data);
        },
    };
    mutations = {
        setLineLoading(state: SaleOrderRequestState, isLoading: boolean) {
            state.lineLoading = isLoading;
        },
        setLineGiftLoading(state: SaleOrderRequestState, isLoading: boolean) {
            state.lineGiftLoading = isLoading;
        },
        setCurrentPage(state: SaleOrderRequestState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SaleOrderRequestState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setGiftCurrentPage(state: SaleOrderRequestState, page: number) {
            state.lineGiftCurrentPage = page;
        },
        setGiftPageSize(state: SaleOrderRequestState, pagesize: number) {
            state.lineGiftPageSize = pagesize;
        },
        setGiftTotalCount(state: SaleOrderRequestState, count: number) {
            state.lineGiftTotalCount = count;
        },
        setLineCurrentPage(state: SaleOrderRequestState, page: number) {
            state.lineCurrentPage = page;
        },
        setLinePageSize(state: SaleOrderRequestState, pagesize: number) {
            state.linePageSize = pagesize;
        },
        setLineTotalCount(state: SaleOrderRequestState, count: number) {
            state.lineTotalCount = count;
        },
        setHistoryCurrentPage(state: SaleOrderRequestState, page: number) {
            state.historyCurrentPage = page;
        },
        setHistoryPageSize(state: SaleOrderRequestState, pagesize: number) {
            state.historyPageSize = pagesize;
        },
        setHistoryTotalCount(state: SaleOrderRequestState, count: number) {
            state.historyTotalCount = count;
        },
        refreshListData(state: SaleOrderRequestState)
        {
            state.list = new Array<SaleOrderRequest>();
        },
    }
}
const saleOrderRequestModule = new SaleOrderRequestModule();
export default saleOrderRequestModule;